<template>
  <div id="modalCreateEditCompany" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Empresa</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <h6 class="mb-0">Dados da Empresa</h6>
              <div class="col-sm-4">
                <label class="form-label">
                  CNPJ: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.company.cnpj.$errors.length }"
                  placeholder="00.000.000/0000-00"
                  v-model="v$.company.cnpj.$model"
                  v-maska="'##.###.###/####-##'"
                  @blur="getReportsByCnpj"
                />
                <span
                  v-if="
                    v$.company.cnpj.required.$invalid &&
                    v$.company.cnpj.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>

                <span
                  v-if="
                    v$.company.cnpj.minLength.$invalid &&
                    v$.company.cnpj.$errors.length
                  "
                  class="invalid-feedback"
                >
                  Formato de CNPJ inválido <br />
                  Ex: 00.000.000/0000-00
                </span>
              </div>
              <div class="col-sm-8">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.company.nome.$errors.length }"
                  placeholder="Nome da Empresa"
                  v-model="v$.company.nome.$model"
                />
                <span
                  v-if="
                    v$.company.nome.required.$invalid &&
                    v$.company.nome.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Usuário: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.company.usuario.$errors.length }"
                  placeholder="Usuário para sincronização de dados"
                  v-model="v$.company.usuario.$model"
                />
                <span
                  v-if="
                    v$.company.usuario.required.$invalid &&
                    v$.company.usuario.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Senha: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.company.senha.$errors.length }"
                  placeholder="Senha para sincronização de dados"
                  v-model="v$.company.senha.$model"
                />
                <span
                  v-if="
                    v$.company.senha.required.$invalid &&
                    v$.company.senha.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Número de Usuários: <span class="text-danger">*</span>
                </label>
                <input
                  type="number"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.company.numUsuario.$errors.length,
                  }"
                  min="1"
                  step="1"
                  placeholder="Número de Usuários"
                  v-model="v$.company.numUsuario.$model"
                />
                <span
                  v-if="
                    v$.company.numUsuario.required.$invalid &&
                    v$.company.numUsuario.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Status: <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="v$.company.status.$model">
                  <option value="" disabled>Selecione</option>
                  <option
                    v-for="option in statusOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <h6 class="mb-0">Contato da Empresa</h6>
              <div class="col-sm-4">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.nome.$errors.length }"
                  placeholder="Nome do Contato"
                  v-model="v$.user.nome.$model"
                />
                <span
                  v-if="
                    v$.user.nome.required.$invalid &&
                    v$.user.nome.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  E-mail: <span class="text-danger">*</span>
                </label>
                <input
                  type="email"
                  class="form-control"
                  :class="{ 'is-invalid': v$.user.email.$errors.length }"
                  placeholder="usuario@email.com.br"
                  v-model="v$.user.email.$model"
                />
                <span
                  v-if="
                    v$.user.email.required.$invalid &&
                    v$.user.email.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="
                    v$.user.email.email.$invalid && v$.user.email.$errors.length
                  "
                  class="invalid-feedback"
                >
                  Formato de e-mail inválido
                </span>
              </div>
              <div class="col-sm-4">
                <label class="form-label">
                  Status: <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="v$.user.status.$model">
                  <option value="" disabled>Selecione</option>
                  <option
                    v-for="option in statusOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <template v-if="reports.length > 0">
                <h6 class="mb-0">
                  Relatórios (Quantidade: {{ reports.length }})
                </h6>
                <div class="table-responsive">
                  <table class="table table-sm table-bordered">
                    <thead>
                      <tr>
                        <th>Hash</th>
                        <th>Nome</th>
                        <th>URL</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="report in reports" :key="report.id">
                        <td>{{ report.hash }}</td>
                        <td>{{ report.nome }}</td>
                        <td>{{ report.url }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-dark"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, maxLength, email } from '@vuelidate/validators'
import { maska } from 'maska'
import { showModal, hideModal } from '@/utils/modal'
import TipoUsuarioEnum from '@/enums/tipoUsuarioEnum'

export default {
  name: 'CreateEditCompanyModal',

  props: {
    companyId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  directives: { maska },

  data() {
    return {
      company: {
        cnpj: '',
        nome: '',
        usuario: '',
        senha: '',
        numUsuario: '',
        status: 1,
      },
      user: {
        nome: '',
        email: '',
        tipo: TipoUsuarioEnum.ADMIN,
        status: 1,
      },
      reports: [],
      statusOptions: [
        { value: 1, text: 'Ativo' },
        { value: 0, text: 'Inativo' },
      ],
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.companyId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getReportsByCnpj() {
      if (this.company.cnpj.length === 18) {
        try {
          this.reports = await this.$store.dispatch('getReportsByCnpj', {
            cnpj: this.company.cnpj,
          })

          if (this.reports.length > 0) {
            this.company.usuario = this.reports[0].userSync
            this.company.senha = this.reports[0].passSync
          }
        } catch (error) {
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },

    async getCompany() {
      try {
        const { company, user } = await this.$store.dispatch(
          'getCompany',
          this.companyId,
        )

        this.company = company
        this.user = user

        this.getReportsByCnpj()

        showModal('modalCreateEditCompany')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.companyId) {
            response = await this.$store.dispatch('updateCompany', {
              id: this.companyId,
              company: this.company,
              user: this.user,
              reports: this.reports,
            })
          } else {
            response = await this.$store.dispatch('createCompany', {
              company: this.company,
              user: this.user,
              reports: this.reports,
            })
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      company: {
        cnpj: {
          required,
          minLength: minLength(18),
          maxLength: maxLength(18),
        },
        nome: {
          required,
        },
        usuario: {
          required,
        },
        senha: {
          required,
        },
        numUsuario: {
          required,
        },
        status: {
          required,
        },
      },
      user: {
        nome: {
          required,
        },
        email: {
          email,
          required,
        },
        status: {
          required,
        },
      },
    }
  },

  mounted() {
    if (this.companyId) {
      this.getCompany()
    } else {
      showModal('modalCreateEditCompany')
    }
  },
}
</script>
